import type { PreClaimsDocumentTypesResponse } from './api';

export const normalizePreClaimsDocumentTypes = (
  list: PreClaimsDocumentTypesResponse,
): {
  label: string;
  value: number;
}[] => {
  if (!list) {
    return [];
  }
  return list.map((row) => ({
    label: row.description,
    value: row.documentType,
  }));
};
